export const locale = {
  lang: 'tr',
  data: {
    'CONTRO_ENCU': {
      'TIT_ENCABE':'Anket kontrolü',
       'CHAN_INFO':'Bilgi yükleniyor',
       'TEX_INTRUCC':'* Filtre(ler)i seçerek arama yapın',
       'SELEC_INSTI':'Enstitü',
       'SELEC_YEA':'Yıl',
       'SELEC_TI_ENC':'Ürünler',
       'SELEC_ESTA':'Durum',
       'BTN_FIL_INFO':'Filtre Anketleri',
       'COMFI_UPDA_TEX':'Güncellemek istediğinizden emin misiniz?',
       'BTN_ACEP':'Kabul Et',
       'BTN_CANC':'İptal',
       'TEX_MOD_UPTD':'Güncelleniyor',
       'TEX_SUCC_MOD_UPTD':'Başarıyla yükseltildi',
       'USE':'Kullanıcı:',
       'DAT':'Tarih:',
       'ACC':'Eylem:',
       'ACC_EVENT':{
       '0':'Devre dışı',
       '1':'Etkin',
     },
      'NAM_TH':{
         'TH_NAM':'Şirket',
          'TH_TI_ENCU':'Anket türü',
          'TH_DAT_APLI':'Başvuru tarihi',
          'TH_ESTA':'Durum',
          'TH_TOKE':'Jeton',
          'TH_HC':'HC',
          'TH_RESPU':'Yanıtlar',
          'TH_DAT_CLO':'Kapanış tarihi',
          'TH_PRORR':'Rollover',
          'TH_REPO_EXC':'Excel raporu',
          'TH_ONLI':'Çevrimiçi',
          'TH_OFFLI':'Çevrimdışı',
          'TH_AUDIT':'Denetim',
          'TH_SECT':'Sektör',
          'TH_SUBSECT':'Alt sektör',
          'TH_LIPROY':'Proje Lideri',
          'TH_JEFPROY':'Proje lideri',
      }
    },
  }
};
